<template>
  <v-row>
    <v-col cols="2" class="align-vertical no-padding">
      <span>{{label}}</span>
    </v-col>
    <v-col cols="1" class="align-vertical no-padding">
      <v-checkbox
        v-model="dmsEnableState"
        item-text="label"
        @change="emitNewVals($event, 'state')"
      />
    </v-col>
    <v-col v-if="displaySpeedThreshold" cols="2" class="align-vertical no-padding">
      <span>Speed Threshold: </span>
    </v-col>
    <v-col v-if="displaySpeedThreshold" cols="2" class="align-vertical no-padding">
      <v-select
        v-model="speedThreshold[selectedUnits]"
        :items="speedThresholdList"
        item-text="label"
        item-value="xml"
        placeholder="Please select threshold"
        @change="emitNewVals(speedThreshold[selectedUnits], 'speed')"
      />
        <span class="speed-units">{{ mapSelectedUnits(selectedUnits) }}</span>
    </v-col>

    <v-col v-if="rateLimiting" cols="2" class="align-vertical no-padding">
      <span>Rate Limit: </span>
    </v-col>
    <v-col v-if="rateLimiting" cols="2" class="align-vertical no-padding">
      <v-select
        v-model="rateLimit"
        :items="rateLimitBand"
        item-text="label"
        item-value="xml"
        placeholder="Please select limit"
        @change="emitNewVals(rateLimit, 'rateLimit')"
      />
    </v-col>
  </v-row>
</template>

<script>

import { Logger } from "aws-amplify";
const logger = new Logger("DMS Alert Configs");

export default {
  name: 'DMSAlertSettings',
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    config: {
      type: Array,
      required: true
    },
    displaySpeedThreshold: {
      type: Boolean,
      required: false,
      default: true
    },
    selectedUnits: {
      required: false,
      type: String,
      default: 'kph'
    },
    rateLimiting: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dmsEnableState: false,
      speedThreshold: {
        kph: 0,
        mph: 0
      },
      thresholdOptions: {
        kph: [
          {
            xml: '0',
            label: '0'
          },
          {
            xml: '10',
            label: '10'
          },
          {
            xml: '20',
            label: '20'
          },
          {
            xml: '30',
            label: '30'
          },
          {
            xml: '40',
            label: '40'
          },
          {
            xml: '50',
            label: '50'
          },
          {
            xml: '60',
            label: '60'
          }
        ],
        mph: [
          {
            xml: '0',
            label: '0'
          },
          {
            xml: '16',
            label: '10'
          },
          {
            xml: '24',
            label: '15'
          },
          {
            xml: '32',
            label: '20'
          },
          {
            xml: '40',
            label: '25'
          },
          {
            xml: '48',
            label: '30'
          },
          {
            xml: '56',
            label: '35'
          }
        ]
      },
      rateLimit: 0,
      test: [1,2,3,4,5,6,7,8]
    }
  },
  computed: {
    speedThresholdList() {
      return this.thresholdOptions[this.selectedUnits];
    },
    rateLimitBand() {
      let band = []

      for (let i = 1; i < 31; i++) {
        band.push(i)
      }

      return band
    }
  },
  watch: {
    selectedUnits() {
      this.mapProps(true);
    }
  },
  mounted() {
    this.mapProps();
  },
  methods: {
    mapProps(unitChange = false) {
      let alert = this.config.find(item => {
        return item.type[0] === this.type;
      });

      if(!alert) return;
      this.dmsEnableState = JSON.parse(alert.enabled[0]);
      logger.info('alert here ', alert)
      // I have to check for the rateLimit attribute as not all devices will have it
      if(alert.hasOwnProperty('rateLimit')) {
        logger.info('yo', alert.rateLimit[0])
        this.rateLimit = parseInt(alert.rateLimit[0]);
      }

      if (this.displaySpeedThreshold) {
        if (!this.selectedUnits) return;
        logger.info('checking ', this.selectedUnits, alert.speed)
        const validSpeed = this.thresholdOptions[this.selectedUnits].find(item => item.xml == alert.speed[0]);

        if(validSpeed) {
          this.speedThreshold[this.selectedUnits] = alert.speed[0];
        }
        else {
          if(this.selectedUnits == 'kph') {
            this.speedThreshold[this.selectedUnits] = '20';
          }
          else if (this.selectedUnits == 'mph') {
            this.speedThreshold[this.selectedUnits] = '32';
          }
        }
        if(unitChange) {
          this.emitNewVals(this.speedThreshold[this.selectedUnits], 'speed')
        }
      }
      
      logger.info(alert)
    },
    eventMap(key, type) {
      const map = {
        state: {
          'phone': 'dmsPhoneAlerts',
          'smoking': 'dmsSmokingAlerts',
          'fatigue': 'dmsFatigueAlerts',
          'distraction': 'dmsDistractionAlerts',
          'occlusion': 'dmsOcclusionAlerts',
        },
          speed: {
          'phone': 'dmsPhoneSpeed',
          'smoking': 'dmsSmokingSpeed',
          'fatigue': 'dmsFatigueSpeed',
          'distraction': 'dmsDistractionSpeed',
          'occlusion': 'dmsOcclusionAlerts'
        },
        rateLimit: {
          'phone': 'dmsPhoneRateLimit',
          'smoking': 'dmsSmokingRateLimit',
          'fatigue': 'dmsFatigueRateLimit',
          'distraction': 'dmsDistractionRateLimit',
          'occlusion': 'dmsOcclusionRateLimit'
        }
      }


      return map[type][key];
    },
    emitNewVals(data, valType) {
      logger.debug("emit new config vals", valType, data)
      this.$emit('dmsAlertsUpdated', data, this.eventMap(this.type, valType), this.type, this.label);
    },
    mapSelectedUnits(units) {
      if (!units) return;

      const map = {
        'kph': 'KPH',
        'mph': 'MPH'
      }

      if (Object.hasOwn(map, units)) {
        return map[units];
      }
      else {
        return 'N/A';
      }

    }
  }
}
</script>

<style lang="scss" scoped>
  .speed-units {
    padding-left: 1em;
  }
</style>